<div class="app flex-row align-items-center bg-login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-header bg-blue" style="font-size: 20px; color: #FFF;">
          <span><i class="fa s-icon-passward fa-fw"></i> パスワードの再発行</span>
        </div>
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <p class="text-muted mb-4">新しいパスワードを登録メールアドレス宛に送信します</p>
              <form (ngSubmit)="resetNow()" #resetForm="ngForm">
                <div class="input-group mb-4">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-login-input"><i class="fa s-icon-user fa-fw text-white"></i></span>
                  </div>
                  <input type="email" class="form-control" placeholder="登録メールアドレスを入力してください"
                    [(ngModel)]="email" name="email" required email>
                </div>
                <div class="row">
                  <div class="col-12 text-right">
                    <a routerLink="/login" class="btn btn-gray-600"><i class="fa s-icon-cancel fa-fw"></i> もどる</a>
                    <button type="submit" class="btn btn-primary text-white"
                      [disabled]="resetForm.invalid || loading"><i class="fa s-icon-reset fa-fw"></i> リセット</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
